import React, { useState } from 'react'
import cn from 'classnames'
import { Collapse, IconButton } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { embedableYoutubeVideo } from 'helpers/youtubeVideo'
import { ReactComponent as ImageIcon } from 'assets/img/image-icon.svg'
import ImageModal from 'components/common/Modals/ImageModal'
import { ReactComponent as CloseIcon } from 'assets/img/close-icon.svg'
import { ReactComponent as VideoIcon } from 'assets/img/video-icon.svg'
import TextEditor from 'components/common/TextEditor'
import Loading from 'components/Loading'
// import FadeInImage from 'components/common/FadeInImage'
import ReactImageAppear from 'react-image-appear'
import messages from '../translate'

function InputGroupInstructions({
  group,
  intl: { formatMessage },
  featureFlags,
}) {
  const { instructions, video, image } = group
  const [showImageBlock, setShowImageBlock] = useState(false)
  const [showVideoBlock, setShowVideoBlock] = useState(false)
  const [isVideoIframeLoading, setIsVideoIframeLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleChangeImageBlock = () => {
    setShowImageBlock(!showImageBlock)
  }

  const handleShowVideo = () => {
    setShowVideoBlock(!showVideoBlock)
    setIsVideoIframeLoading(false)
  }

  const handleModalChange = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleChangeLoader = () => {
    setIsVideoIframeLoading(false)
  }

  const embededVideo = embedableYoutubeVideo(video)
  const imageTitle = showImageBlock ? messages.hideImage : messages.showImage
  const videoTitle = showVideoBlock ? messages.hideVideo : messages.showVideo

  return (
    <div className="job-task-notification">
      <span className="job-task-notification-icon">i</span>
      {instructions && (
        <div
          className={cn('job-task-notification-title', {
            noPreLine: featureFlags.INSTRUCTIONS_TEXT_EDITOR,
          })}>
          {featureFlags.INSTRUCTIONS_TEXT_EDITOR ? (
            <TextEditor
              input={{ value: instructions }}
              showToolbar={false}
              readOnly
            />
          ) : (
            instructions
          )}
        </div>
      )}
      {image && (
        <div
          className={cn('wrap', {
            showBlock: showImageBlock,
          })}>
          <ImageIcon />
          <div className="title" onClick={handleChangeImageBlock}>
            {formatMessage(imageTitle)}
          </div>
          <Collapse in={showImageBlock}>
            <img // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
              className="image"
              src={image}
              onClick={handleModalChange}
              alt=""
            />
            <ImageModal open={isModalOpen} onClose={handleModalChange}>
              <div className="modal-content">
                <div className="image-wrap-content">
                  {/* <FadeInImage */}
                  {/*  src={image} */}
                  {/*  placeholderStyle={{ */}
                  {/*    backgroundColor: 'transparent', */}
                  {/*  }} */}
                  {/* /> */}
                  <ReactImageAppear
                    src={image}
                    animationDuration="2s"
                    placeholderStyle={{
                      backgroundColor: 'transparent',
                    }}
                  />
                </div>
                <div className="btn-wrap">
                  <IconButton onClick={handleModalChange}>
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
            </ImageModal>
          </Collapse>
        </div>
      )}
      {embededVideo && (
        <div className={cn('wrap', { showBlock: showVideoBlock })}>
          <VideoIcon />
          <div className="title" onClick={handleShowVideo}>
            {formatMessage(videoTitle)}
          </div>
          <Collapse in={showVideoBlock}>
            <div className="iframe-wrapper">
              {isVideoIframeLoading && <Loading pastDelay />}
              <iframe
                src={embededVideo}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                title="video"
                allowFullScreen="1"
                onLoad={handleChangeLoader}
              />
            </div>
          </Collapse>
        </div>
      )}
    </div>
  )
}

export default connect(state => ({
  featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
}))(injectIntl(InputGroupInstructions))
